export const getLoginReducer = state => state.loginReducer
